// components/MessageItem.tsx
import React from 'react';
import { useClipShare } from '../hooks/useClipShare';
import { useLanguage } from '../context/LanguageContext';
import { ClipboardMessage } from '../types';

interface MessageItemProps {
  message: ClipboardMessage;
}

export const MessageItem: React.FC<MessageItemProps> = ({ message }) => {
  const { copyToClipboard, showContextMenu } = useClipShare();
  const { t } = useLanguage();

  const handleClick = () => {
    copyToClipboard({
      type: message.type,
      content: message.content
    });
  };

  const handleContextMenu = (e: React.MouseEvent) => {
    showContextMenu(e, {
      type: message.type,
      content: message.content
    });
  };

  const formatTime = (timestamp: number) => {
    return new Date(timestamp).toLocaleTimeString();
  };

  const escapeHtml = (text: string) => {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  };

  return (
    <div 
      className="message"
      onClick={handleClick}
      onContextMenu={handleContextMenu}
    >
      <div className="message-header">
        <span>👤 {message.participantName}</span>
        <span>{formatTime(message.timestamp)}</span>
      </div>
      
      {message.type === 'text' ? (
        <div 
          className="message-content"
          dangerouslySetInnerHTML={{ __html: escapeHtml(message.content) }}
        />
      ) : (
        <>
          <div className="message-content">{t.image}</div>
          <img 
            src={message.content} 
            className="message-image" 
            alt="Shared image"
            style={{ maxWidth: '100%', maxHeight: '300px', borderRadius: '8px', marginTop: '10px' }}
          />
        </>
      )}
    </div>
  );
};
